module.exports = __webpack_public_path__ + "img/defaultCoinIco.67af785a.png";